import React from "react";
import RegistrationCard from "../../RegistrationCard";
import MinorInfoForm from "./MinorInfoForm";

const MinorInfo = ({ currentRegistration, onSubmit, match }) => {
  // Firebase has trouble with deeply nested objects that are arrays so you
  // have to modify the push data to use a nested update syntax.
  //
  // Additionally we need to pass the complete nested object or else it
  // gets overwritten, so for minors we pass in the contact information along
  // with the address initial values.

  const { index } = match.params;
  const initialValues = {
    nextStep: `minors/${index}/address`
  };

  if (currentRegistration.minors && currentRegistration.minors[index]) {
    const {
      firstName,
      lastName,
      address,
      city,
      province,
      postal,
      country
    } = currentRegistration.minors[index];
    let { address2, dateOfBirth } = currentRegistration.minors[index];
    address2 = address2 || null;
    dateOfBirth = dateOfBirth || null;

    //use registration phone as default value
    let { phone } = currentRegistration.minors[index];
    phone = phone ? phone : currentRegistration.phone;

    initialValues[`minors/${index}`] = {
      firstName,
      lastName,
      phone,
      dateOfBirth,
      address,
      address2,
      city,
      province,
      postal,
      country
    };
  } else {
    if (currentRegistration.phone) {
      initialValues[`minors/${index}`] = {
        //use registration phone as default value
        phone: currentRegistration.phone
      };
    }
  }

  return (
    <RegistrationCard
      title="Enter the minor's information"
      subtitle="For shooting range purposes, a minor is anyone between the ages of 12 and 21"
    >
      <MinorInfoForm
        onSubmit={onSubmit}
        initialValues={initialValues}
        index={index}
      />
    </RegistrationCard>
  );
};

MinorInfo.propTypes = {};
MinorInfo.defaultProps = {};

export default MinorInfo;



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorInfo/MinorInfo.jsx